import styled from "styled-components";

export const Perguntas = styled.div`
  padding: 43px;
  background-color: var(--blue-white);

  section {
    width: 100%;
    height: 100%;
    max-width: 1300px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    #todas-perguntas {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 15px;

      #pense {
        font-weight: 700;
        font-size: 12px;
        line-height: 140%;
        text-transform: uppercase;
        text-align: left;
        width: 100%;
        color: var(--orange);
      }

      h1 {
        font-weight: 700;
        font-size: 26px;
        line-height: 122%;
      }

      ul {
        display: flex;
        flex-direction: column;
        gap: 10px;

        li {
          font-size: 14px;
          line-height: 160%;

          ::marker {
            color: var(--orange);
          }

          span {
            font-weight: 700;
          }
        }
      }
    }

    figure {
      width: 100%;

      img {
        width: 100%;
      }
    }
  }

  @media (min-width: 601px) {
    section {
      margin: 0 auto;
      height: 695px;
      flex-direction: row-reverse;

      #todas-perguntas {
        width: 50%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 35px;

        #pense {
          font-size: 16px;
        }

        h1 {
          font-size: 48px;
        }

        ul {
          gap: 25px;
          padding-left: 30px;
          li {
            font-size: 16px;
          }
        }
      }

      figure {
        width: 50%;

        img {
          width: 100%;
        }
      }
    }
  }
`;
